import { useQuery } from "@tanstack/react-query";
import { fetchEventConfig } from "./eventConfig.ts";

export function useEventConfig(slug: string) {
  return useQuery({
    queryKey: ["event", slug],
    queryFn: () => fetchEventConfig(slug),
    enabled: slug.length > 0,
  });
}
